import React from 'react';
import { EditIcon, AddIcon } from '@chakra-ui/icons'
const CreateCaseButton =(props) => {
  const clickAction = ()=>{
    props.onClick(props.data)
  }
  return (
    <div>
      {(props.label==='view' || (Array.isArray(props.data.case) && props.data.case.length > 0)) && 
          <EditIcon onClick={clickAction} style={{cursor:"pointer"}}/>
      }
      {(props.label==='add' && (Array.isArray(props.data.case) && props.data.case.length <= 0)) && 
          <AddIcon onClick={clickAction} style={{cursor:"pointer"}}/>
      }
    </div>
  );
};
export default React.memo(CreateCaseButton);